var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { SelectCssClass, SelectWidth, } from '../../../../components/src/components/select/select.types';
import { GlobalCssClass, } from '../../../../components/src/utils/interfaces';
import { IressInput, IressLabel } from '../../wrappers';
import { transformTag } from '../../utils/helpers';
let selectIds = 0;
class IressSelect extends React.Component {
    constructor(props) {
        super(props);
        this.selectId = `iress-select-${selectIds++}`;
        this.component = React.createRef();
        this.nativeInput = React.createRef();
        this.updateCurrentValue = (el) => {
            let defaultOption = el.querySelector(`option[value=""]`);
            let defaultValue = '';
            if (!defaultOption) {
                defaultOption = el.querySelectorAll(`option`)[0];
                defaultValue = defaultOption.value;
            }
            defaultOption.selected = true;
            this.setState({ currentValue: defaultValue });
        };
        this.validateProps = (props) => props.children && Array.isArray(props.children);
        this.registerSelect = (el) => {
            var _a;
            this.fieldEl = el.closest(transformTag('iress-field'));
            (_a = this.fieldEl) === null || _a === void 0 ? void 0 : _a.addEventListener('iressFieldDidLoad', () => __awaiter(this, void 0, void 0, function* () {
                yield this.fieldEl.registerInputElement(this.getStatus());
            }));
        };
        this.updateField = () => __awaiter(this, void 0, void 0, function* () {
            if (this.fieldEl) {
                yield this.fieldEl.registerInputElement(this.getStatus());
            }
        });
        this.getOptionsFromProp = (props) => JSON.stringify(props.children.map((child) => child.props.value));
        this.getStatus = (newValue) => ({
            value: newValue !== undefined ? newValue : this.state.currentValue,
            element: this.nativeInput.current
                ? this.nativeInput.current
                : undefined,
            name: this.props.name ? this.props.name : this.selectId,
            required: this.props.required || false,
            error: this.state.error,
            label: this.props.multiInputLabel,
        });
        this.getSelectedOptionText = (value, children) => {
            const selectedOption = value
                ? children.filter((child) => child.props.value === value)
                : null;
            return selectedOption && selectedOption.length > 0
                ? selectedOption[0].props.children
                : '';
        };
        this.updateErrors = (valMsg) => {
            if ((this.state.error !== '' && valMsg === '') ||
                (this.state.error === '' && valMsg !== '')) {
                if (this.nativeInput.current &&
                    this.nativeInput.current.value !== this.state.currentValue) {
                    this.setState({
                        currentValue: this.nativeInput.current.value,
                    });
                }
                const event = new CustomEvent('iressErrorChange', {
                    bubbles: true,
                    detail: this.getStatus(),
                });
                // Dispatch the event.
                this.nativeInput.current &&
                    this.nativeInput.current.dispatchEvent(event);
            }
            this.setState({ error: valMsg });
        };
        this.handleEvent = (event, newValue) => {
            event && event(this.getStatus(newValue));
        };
        this.handleChange = (event) => {
            const el = this.nativeInput.current;
            let value = this.state.currentValue;
            if (el && el.value !== this.state.currentValue) {
                this.setState({ currentValue: el.value });
                value = el.value;
            }
            this.handleEvent(event, value);
        };
        this.getCssClasses = (width, hiddenLabel, required, className) => {
            const widthClass = width &&
                `${SelectCssClass[`Width${width}`]} ${GlobalCssClass.IgnoreStack}`;
            return `${SelectCssClass.Base} ${GlobalCssClass.FormElement} ${this.state.error ? GlobalCssClass.FormElementInvalid : ``} ${hiddenLabel ? SelectCssClass.HiddenLabel : ``} ${required ? SelectCssClass.Required : ``} ${width ? widthClass : ''} ${className}`;
        };
        this.state = {
            error: '',
            currentValue: props.value ? props.value : '',
        };
    }
    componentDidMount() {
        if (this.component.current) {
            // 'Mocking' web component methods
            this.component.current['validate'] = () => {
                const fieldError = this.fieldEl && this.fieldEl.error
                    ? this.fieldEl.error
                    : '';
                this.nativeInput.current &&
                    this.updateErrors(this.nativeInput.current.validationMessage ||
                        fieldError);
            };
            this.component.current['getNativeElement'] =
                () => __awaiter(this, void 0, void 0, function* () {
                    return Promise.resolve(this.nativeInput.current);
                });
            this.component.current['reset'] = () => __awaiter(this, void 0, void 0, function* () {
                this.setState({
                    error: '',
                    currentValue: '',
                });
            });
        }
        // Register the select with field.
        if (this.nativeInput.current) {
            const selectedOpt = this.nativeInput.current.querySelector(`option[value="${this.props.value}"]`);
            if (selectedOpt)
                selectedOpt.setAttribute('selected', 'selected');
            this.registerSelect(this.nativeInput.current);
        }
    }
    componentWillUnmount() {
        if (this.nativeInput.current &&
            this.fieldEl &&
            typeof this.fieldEl.unregisterInputElement === 'function') {
            this.fieldEl.unregisterInputElement(this.getStatus());
        }
    }
    componentDidUpdate(prevProps) {
        var _a;
        const el = this.nativeInput.current;
        const currVal = this.state.currentValue;
        const requiredUpdated = prevProps.required !== this.props.required;
        if (requiredUpdated && ((_a = this.nativeInput) === null || _a === void 0 ? void 0 : _a.current) !== null) {
            this.updateField();
        }
        // See if list of options has changed
        if (this.validateProps(prevProps) && this.validateProps(this.props)) {
            const prevOpts = this.getOptionsFromProp(prevProps);
            const newOpts = this.getOptionsFromProp(this.props);
            // Check to see if current value exists in new options and checking if new and prevous options are different.
            if (!newOpts.includes(currVal) && prevOpts !== newOpts && el) {
                this.updateCurrentValue(el);
            }
        }
        if (this.props.value !== undefined &&
            prevProps.value !== this.props.value) {
            this.setState({ currentValue: this.props.value });
        }
    }
    render() {
        const _a = this.props, { hiddenLabel, multiInputLabel, name, optional, required, placeholder, onLoad, onChange, onBlur, onFocus, children, width, className, readonly, value } = _a, selectProps = __rest(_a, ["hiddenLabel", "multiInputLabel", "name", "optional", "required", "placeholder", "onLoad", "onChange", "onBlur", "onFocus", "children", "width", "className", "readonly", "value"]);
        const nativeDataTestid = selectProps['data-testid']
            ? `${selectProps['data-testid']}__select`
            : null;
        return (React.createElement("div", Object.assign({ className: this.getCssClasses(width, hiddenLabel, required, className), ref: this.component }, selectProps),
            multiInputLabel && (React.createElement(IressLabel, { className: SelectCssClass.Label, for: this.selectId, labelText: multiInputLabel, required: required, optional: optional, hiddenLabel: hiddenLabel })),
            !readonly ? (React.createElement("div", { className: SelectCssClass.Wrapper },
                React.createElement("select", { name: name, id: this.selectId, className: SelectCssClass.Select, required: required, onFocus: () => this.handleEvent(onFocus), onBlur: () => this.handleEvent(onBlur), onChange: () => this.handleChange(onChange), onLoad: () => this.handleEvent(onLoad), ref: this.nativeInput, "data-testid": nativeDataTestid, value: this.state.currentValue },
                    placeholder && (React.createElement("option", { value: "" }, placeholder)),
                    children))) : (React.createElement("div", null,
                React.createElement(IressInput, { readonly: true, width: width, required: required, value: value &&
                        this.getSelectedOptionText(value, children), onInput: undefined }),
                React.createElement("input", { name: name, id: this.selectId, required: required, "data-testid": nativeDataTestid, type: "hidden", value: value, readOnly: true })))));
    }
}
IressSelect.Width = SelectWidth;
export { IressSelect };
//# sourceMappingURL=IressSelect.js.map